import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=64833a7b&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64833a7b')) {
      api.createRecord('64833a7b', component.options)
    } else {
      api.reload('64833a7b', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=64833a7b&", function () {
      api.rerender('64833a7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Mo2X9fRQS6NY/JS/pricehelp.vue"
export default component.exports